import { ITimelineTracking } from "types/timelineTracking";
import { createDataAtom } from "../jotaiUtility";
import { IShipmentOrderCollection } from "types/shipmentOrderCollection";

export const shipmentOrderCollectionAtom =
  createDataAtom<IShipmentOrderCollection>();

export const shipmentProductTimelineTrackingAtom =
  createDataAtom<ITimelineTracking>();
